export default __webpack_public_path__ + "static/staff-augmentation-dc0116cbb890924f7eb7010456a21d96.webp";